<div class="delivery-address-list">
  <h3 class="delivery-address-list-title text-h5-s text-md-h4-s">мои адреса</h3>
  <div class="delivery-address-list-wrapper">
    <sd-delivery-add-address text="добавить адрес" />
    <div class="delivery-address-list-items">
      @if (loading()) {
        <div class="sd-group-skeleton-gradient-wave">
          <div class="sd-skeleton"></div>
          <div class="sd-skeleton"></div>
          <div class="sd-skeleton"></div>
        </div>
      } @else {
        @for (address of addressList(); track address.id) {
          <sd-delivery-address [address]="address" />
        }
      }
    </div>
  </div>
</div>
